
/*
var hasTarget = $('.has-target-dropdown option:selected').data('has-target') ? true : false;
var Type= $('.has-target-dropdown option:selected').data('itype');
var idtarget=$('.has-target-dropdown option:selected').val();
var $targetInput = $('.messages-has-target .target-input');
var $targetModal=$(".target-modal");
var $targetName=$(".form-control.target-choice-name");
var currentTargetId=$(".hiddentarget");

var UpdateModal=function(resource_id,target_id,expand_cat) {
    var hasTarget = $('.has-target-dropdown option:selected').data('has-target') ? true : false;
    var Type= $('.has-target-dropdown option:selected').data('itype');
    var idtarget=$('.has-target-dropdown option:selected').val();
    $.getJSON("/push/tree",{target_id:target_id,resource_id:resource_id,expand_cat:expand_cat},function(data){
        $(".modal-choice-left").html(data.left);
        $(".modal-choice-right").html(data.right);
        $targetName.val(data.currentName);
        $(".modal-choice-left").find('i').on("click",function(){
            if($(this).hasClass("zmdi-plus")) {
                $(this).closest("li").addClass("active").removeClass("inactive");
                $(this).removeClass("zmdi-plus").addClass("zmdi-minus");
            }else{
                $(this).closest("li").removeClass("active").addClass("inactive");
                $(this).removeClass("zmdi-minus").addClass("zmdi-plus");
            }
            return false;
        });

        $(".modal-choice-left").find('.content').on("click",function() {
            $this=$(this);
            $parent=$this.closest("li");
            var expand_id=$parent.data("id");
            console.log('click',expand_id);
            UpdateModal(idtarget,currentTargetId.val(),expand_id);
        });

        $(".modal-choice-right").find('li').on("click",function(){
            $this=$(this);
            $this.parent().find("li .card-push-display").removeClass("active");
            $this.find(".card-push-display").addClass("active");
            currentTargetId.val($this.data("id"));
            UpdateModal(idtarget,currentTargetId.val());

        })

        if(currentTargetId.val().length) {
            $(".choice-button-ex").prop("disabled",false);
        }else{
            $(".choice-button-ex").prop("disabled",true);
        }
    });
};

$('.messages-has-target .has-target-dropdown').length && UpdateModal(idtarget,currentTargetId.val());

$('.messages-has-target .target-input select').on("change",function(){
    $(".hiddentarget").val($(this).val());
});

$("body").on("click","[data-push-target-id]",function() {
    var $el = $(this);
    $el.parent().find(".card-push-display").removeClass("active");
    $el.find(".card-push-display").addClass("active");
    var id = $el.attr("data-push-target-id");
    var title = $el.find(".content-place h4").text();
    console.log('test',id,title);
    currentTargetId.val(id);
    $targetName.val(title);
    if(currentTargetId.val().length) {
        $(".choice-button-ex").prop("disabled",false);
    }else{
        $(".choice-button-ex").prop("disabled",true);
    }
});

$('.messages-has-target .has-target-dropdown').change(function(){
    var hasTarget = $('.has-target-dropdown option:selected').data('has-target') ? true : false;
    var Type= $('.has-target-dropdown option:selected').data('itype');
    var idtarget=$('.has-target-dropdown option:selected').val();

    console.log(idtarget, hasTarget);

    if (hasTarget) {
        $targetInput.slideUp();
        $targetModal.slideUp();
        if(Type==="modal-choice") {
            $targetModal.slideDown();
            UpdateModal(idtarget,currentTargetId.val());
        }else {

            $.getJSON("/push/targets/" + idtarget,{t: (new Date()).toUTCString()}, function (data) {
                if (data && data.list) {
                    console.log(data.list);
                }
                $targetInput.find("option").remove();
                var items=[];
                $.each(data.list, function(key, val) {
                    items.push({k:key,v:val});
                });

                $(".modal-choice-target").html("");
                var ee = 0;
                $.each(items, function (key, val) {
                    $(".modal-choice-target").append(val.v);
                    if(ee++ == 1) {
                        ee = 0;
                        $(".modal-choice-target").append('<div style="clear:both;"></div>');
                    }
                    var option = $("<option></option>");
                    option.attr("value", val.k);
                    option.text(val.v);

                    $targetInput.find("select").append(option);
                });

                $targetInput.slideDown();
            });
        }
    } else {
        $targetInput.slideUp();
        $targetModal.slideUp();
    }
});
*/
